import React, { useEffect, useRef } from 'react';

import styles from './LimitationLiabilityModal.module.scss';

export const LimitationLiabilityModal = () => {
  const agreeButtonRef = useRef(null);

  useEffect(() => {
    if (agreeButtonRef.current) agreeButtonRef.current.focus();
  }, []);

  return (
    <div className={styles.bns3_liability_container}>
      <h2 className={styles.bns3_liability_title}>Limitation of Liability</h2>

      <div className={styles.bns3_liability_body}>
        <p className={styles.bns3_liability_text}>
          The user agrees that he or she is making use of our services at his or her own risk and that they are being
          provided on an "as is" and "as available" basis. The company will not bear any responsibility for the content
          of listings posted on the website and for any losses caused by the use of our services.
        </p>

        <p className={styles.bns3_liability_text}>
          The company is not an organizer or an initiator of transactions between the users. The website is a
          marketplace that enables users to list, sell and purchase legally compliant items and services at any time,
          from anywhere and at any price.
        </p>

        <p className={styles.bns3_liability_text}>
          The company does not guarantee the accuracy of the information in the listings posted on the website. The
          quality, safety, legality and compliance of a product or service with their description, as well as the
          ability of the user to sell or buy a product or service are beyond the control of the company. The company is
          not liable for any damage resulting from a transaction or misconduct by any of the parties.
        </p>

        <p className={styles.bns3_liability_text}>
          The company is not responsible for the user actions or inactions and the listings being posted. The users
          should resolve all disputes and conflicts on their own without involving the company.
        </p>
      </div>

      {/* TODO. Button should do smth */}
      <button className={styles.bns3_liability_agree_button} ref={agreeButtonRef}>
        Agree
      </button>
    </div>
  );
};
